import { Component } from '@angular/core';
import { TimeDateSensorInputComponent } from '../time-date-sensor-input/time-date-sensor-input.component';

@Component({
    selector: 'dl-real-time-sensor',
    styles: [
        `
            :host label {
                display: block;
                font-size: 12px;
            }
        `
    ],
    templateUrl: '../time-date-sensor-input/time-date-sensor-input.component.html'
})
export class RealTimeSensorInputComponent extends TimeDateSensorInputComponent {
    public static $name: string = 'realTimeSensor';
}
